import { createBrowserRouter } from "react-router-dom";
import DefaultLayout from "./Layouts/DefaultLayout";
import GuestLayout from "./Layouts/GuestLayout";
import Login from "./Components/Auth/Login";
import Register from "./Components/Auth/Register";
import Home from "./Components/Home";
import Products from "./Components/Products";
import SingleProduct from "./Components/SingleProduct";
import Cart from "./Components/Cart";
import Dashboard from "./Layouts/Dashboard";
import AddProduct from "./Components/Dashboard/AddProduct";
import AddCategory from "./Components/Dashboard/AddCategory";
import Checkout from "./Components/Checkout";
import Quote from "./Components/Quote";
import WishList from "./Components/WishList";
import ScrollTop from "./Components/ScrollTop";
import PaypalPayment from "./Components/PaypalPayment";
import OrdersList from "./Components/Dashboard/OrdersList";
import MyOrders from "./Components/Dashboard/MyOrders";
import ShippingZone from "./Components/Dashboard/ShippingZone";
import About from "./Components/PolicyPages/About";
import FAQ from "./Components/PolicyPages/Faq";

const routes = createBrowserRouter([
  {
    path: '/',
    element: (
    <>
    <ScrollTop />
    <DefaultLayout />
    </>
   ),
    children: [
      {
        path: '/',
        element: (
            <Home />
          
        )
      },
      {
        path: '/products/:id',
        element: (

            <Products />
         
        )
      },
      {
        path: '/singleproduct/:id',
        element: (
          
            
            <SingleProduct />
        
        )
      },
      {
        path: '/viewcart',
        element: (
       
           
            <Cart />
       
        )
      },
      {
        path: '/checkout',
        element: (
          
            
            <Checkout />
         
        )
      },
      {
        path: '/payment',
        element: (
          
            
            <PaypalPayment />
         
        )
      },
      {
        path: '/quote',
        element: (
     
          
            <Quote />
         
        )
      },
      {
        path: '/wishlist',
        element: (
        
          
            <WishList />
         
        )
      },
      {
        path: '/about',
        element: (
        
          
            <About />
         
        )
      },
       {
        path: '/faq',
        element: (
        
          
            <FAQ />
         
        )
      },
      {
        path: '/myorders',
        element: (
        
          
            <MyOrders />
       
        )
      }
    ]
  },
  {
    path: '/dashboard',
    element:(
        <>
        <ScrollTop/>
        <Dashboard />
        </>
       ),
    children: [
      {
        path: '/dashboard/addproduct',
        element: (
          <>
            <ScrollTop />
            <AddProduct />
          </>
        )
      },
      {
        path: '/dashboard/addcategory',
        element: (
          <>
            <ScrollTop />
            <AddCategory />
          </>
        )
      },
      {
        path: '/dashboard/orderslist',
        element: (
          <>
            <ScrollTop />
            <OrdersList />
          </>
        )
      }
      ,
      {
        path: '/dashboard/shippingzone',
        element: (
          <>
            <ScrollTop />
            <ShippingZone />
          </>
        )
      }
    ]
  },
  {
    path: '/',
    element: <GuestLayout />,
    children: [
      {
        path: '/login',
        element: (
          <>
            <ScrollTop />
            <Login />
          </>
        )
      },
      {
        path: '/register',
        element: (
          <>
            <ScrollTop />
            <Register />
          </>
        )
      }
    ]
  }
]);

export default routes;
